import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import useLoad from "./useLoad";
var defaultOptions = {
  key: undefined,
  imperative: true,
  independent: true,
  initialData: undefined,
  defaultParams: undefined,
  cacheKey: undefined,
  staleTime: 0,
  polling: false,
  pollingInPageHiding: false,
  autoReloadOnPageShow: false,
  autoReloadOnWindowFocus: false,
  autoReloadOnNetworkReconnect: false
};
function useSubmit(callback, options) {
  var _useLoad = useLoad(callback, [], _objectSpread(_objectSpread({}, options), defaultOptions)),
    submit = _useLoad.force,
    submitting = _useLoad.loading;
  return {
    submit: submit,
    submitting: submitting
  };
}
export default useSubmit;